// Attribution capture only. Conversion events are sent by the backend after mobile verification.
export const getAttribution = () => {
  try {
    const api = window.domiumAttribution;
    return api?.capture?.() ?? api?.read?.();
  } catch (_) {
    return undefined;
  }
};
